var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 12.4C10.8778 12.4 12.4 10.8778 12.4 9C12.4 7.12223 10.8778 5.6 9 5.6C7.12223 5.6 5.6 7.12223 5.6 9C5.6 10.8778 7.12223 12.4 9 12.4Z",
    stroke: "#757575",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17 17.6C18.4359 17.6 19.6 16.4359 19.6 15C19.6 13.5641 18.4359 12.4 17 12.4C15.5641 12.4 14.4 13.5641 14.4 15C14.4 16.4359 15.5641 17.6 17 17.6Z",
    stroke: "#757575",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3 19C3 16.2 5.7 14.4 9 14.4",
    stroke: "#757575",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavCircle);
export default __webpack_public_path__ + "static/media/nav-circle.009c7e3aa9e2ffaab96a74c8e1806559.svg";
export { ForwardRef as ReactComponent };